var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ClientInput"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$props.title))]),_c('input',{attrs:{"type":"text"},domProps:{"value":_vm.$props.value},on:{"input":(e)=>_vm.onChange(e.target.value)}}),(_vm.$props.unit)?_c('div',{staticClass:"unit"},[_vm._v(_vm._s(_vm.$props.unit))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }